/** Learner entry may resume only a same-origin portal route. */
export function learnerReturnPath(value: string | null | undefined): string | null {
  if (!value) return null;
  for (const character of value) {
    if (character === '\\' || character.charCodeAt(0) <= 0x20) return null;
  }
  try {
    const url = new URL(value, 'https://learner.invalid');
    if (url.origin !== 'https://learner.invalid' || !value.startsWith('/') ||
      (url.pathname !== '/portal' && !url.pathname.startsWith('/portal/'))) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
